export default [
  {
    key: 'increasement',
    sortable: false,
    sortField: '',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'username',
    sortable: false,
    sortField: 'username',
    label: 'field.username',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'name',
    sortable: false,
    label: 'field.name',
  },
  {
    key: 'amount',
    sortable: false,
    sortField: '',
    label: 'field.amount',
    tdClass: 'text-right',
  },
  {
    key: 'qrCodeUrl',
    sortable: false,
    sortField: '',
    label: 'field.qrCode',
    tdClass: 'text-center',
  },
  {
    key: 'createdAt',
    sortable: false,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
  {
    key: 'status',
    sortable: false,
    sortField: 'status',
    label: 'field.status',
  },
  {
    key: 'type',
    sortable: false,
    label: 'field.type',
  },
  {
    key: 'bankName',
    sortable: false,
    sortField: '',
    label: 'field.bank',
    tdClass: 'text-right',
  },
  {
    key: 'accountNumber',
    sortable: false,
    sortField: '',
    label: 'field.accountNumber',
    tdClass: 'text-right',
  },
  {
    key: 'accountHolder',
    sortable: false,
    sortField: '',
    label: 'field.accountHolder',
    tdClass: 'text-right',
  },
  {
    key: 'accountHolder',
    sortable: false,
    sortField: '',
    label: 'field.accountHolder',
    tdClass: 'text-right',
  },
  {
    key: 'phoneNumber',
    sortable: false,
    label: 'field.phoneNumber',
  },
  {
    key: 'verifier',
    label: 'field.verifier',
  },
]
